import nodeDescriptions from './nodeDescriptions';
import nodeStates from './nodeStates';

export default [
    {
        nodeTypes: [nodeDescriptions.creation],
        state: nodeStates.completedBag,
        translationKey: 'created',
    },

    {
        nodeTypes: [nodeDescriptions.activation],
        state: nodeStates.completedBag,
        translationKey: 'activated',
    },
    {
        nodeTypes: [nodeDescriptions.activation],
        state: nodeStates.missed,
        translationKey: 'noActivation',
    },
    {
        nodeTypes: [nodeDescriptions.activation],
        state: nodeStates.future,
        translationKey: 'expectedActivation',
    },
    {
        nodeTypes: [nodeDescriptions.load],
        state: nodeStates.completedBag,
        translationKey: 'loaded',
    },
    {
        nodeTypes: [nodeDescriptions.load],
        state: nodeStates.missed,
        translationKey: 'noLoadScan',
    },
    {
        nodeTypes: [nodeDescriptions.load],
        state: nodeStates.future,
        translationKey: 'loadScan',
    },
    {
        nodeTypes: [nodeDescriptions.offload],
        state: nodeStates.completedBag,
        translationKey: 'offloaded',
    },
    {
        nodeTypes: [nodeDescriptions.uldPositioning],
        state: nodeStates.completedBag,
        translationKey: 'uldPositioned',
    },
    {
        nodeTypes: [nodeDescriptions.reflight],
        state: nodeStates.completedReflight,
        translationKey: 'reflighted',
    },
    {
        nodeTypes: [nodeDescriptions.departure],
        state: nodeStates.completedFlight,
        translationKey: 'flightDeparted',
    },
    {
        nodeTypes: [nodeDescriptions.departure],
        state: nodeStates.future,
        translationKey: 'flightToDepart',
    },
    {
        nodeTypes: [nodeDescriptions.arrival],
        state: nodeStates.completedFlight,
        translationKey: 'flightArrived',
    },
    {
        nodeTypes: [nodeDescriptions.arrival],
        state: nodeStates.future,
        translationKey: 'flightToArrive',
    },
    {
        nodeTypes: [nodeDescriptions.flightCancelled],
        translationKey: 'flightDeleted',
    },
    {
        nodeTypes: [nodeDescriptions.unload],
        state: nodeStates.completedBag,
        translationKey: 'unloaded',
    },
    {
        nodeTypes: [nodeDescriptions.delivery],
        translationKey: 'delivered',
        state: nodeStates.completedBag,
    },
];
